
export {CSSTransition,
ReplaceTransition,
SwitchTransition,
TransitionGroup,
Transition,
config} from '../../../frontend-js-dependencies-web/__liferay__/exports/react-transition-group.js';
